"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  general: {
    siteTitle: 'BBC Science Focus Magazine'
  },
  enableAmpOnPostType: {
    post: true,
    editorialList: true,
    recipe: true
  }
};
exports["default"] = _default;